module.exports = __webpack_public_path__ + "img/eyeOn.0b098bc6.svg";